var _path, _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToastCheckEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 180,
    viewBox: "0 0 296 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264.615 20.3023C286.804 27.7616 294.174 62.5172 295.276 95.7867C296.571 128.836 291.598 160.399 271.818 172.547C251.8 184.523 216.952 176.887 188.402 174.909C160.068 172.907 137.987 176.168 103.552 170.276C69.3098 164.163 22.7137 148.896 6.93655 118.856C-8.86253 88.6202 5.72688 43.6595 37.9907 30.1168C70.0174 16.4018 119.503 34.1288 162.772 33.2701C205.804 32.2392 242.62 12.6226 264.615 20.3023Z",
    fill: "#CAF2ED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_133_28948",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 0,
    width: 187,
    height: 125
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 62.6353,
    width: 186,
    height: 125,
    rx: 5,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_133_28948)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.6353,
    width: 186,
    height: 125,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.6353,
    y: 40,
    width: 60,
    height: 6,
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.6353,
    y: 51.0002,
    width: 75,
    height: 3,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.6353,
    y: 57,
    width: 84,
    height: 3,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.6353,
    y: 63.0002,
    width: 74,
    height: 3,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.6353,
    y: 79,
    width: 25,
    height: 3,
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.6353,
    y: 88.9998,
    width: 25,
    height: 3,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.6353,
    y: 96,
    width: 25,
    height: 3,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.6353,
    y: 103,
    width: 25,
    height: 3,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.635,
    y: 79,
    width: 25,
    height: 3,
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.635,
    y: 88.9998,
    width: 25,
    height: 3,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.635,
    y: 96,
    width: 25,
    height: 3,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.635,
    y: 103,
    width: 25,
    height: 3,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.635,
    y: 79,
    width: 25,
    height: 3,
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.635,
    y: 88.9998,
    width: 25,
    height: 3,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.635,
    y: 96,
    width: 25,
    height: 3,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.635,
    y: 103,
    width: 25,
    height: 3,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.6353,
    width: 186,
    height: 17,
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.6355,
    width: 125,
    height: 17,
    transform: "rotate(90 79.6355 0)",
    fill: "#EAF1FB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.6353,
    width: 17,
    height: 17,
    fill: "#D3E3FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8577 5.58309C67.6858 5.58309 67.5522 5.73587 67.5522 5.88864L67.5522 6.32788L70.8369 9.02059C71.2379 9.34524 71.7917 9.34524 72.1928 9.02059L75.4966 6.32788L75.4966 5.88864C75.4966 5.73587 75.3438 5.58309 75.1911 5.58309L67.8577 5.58309ZM67.5522 7.51191L67.5522 10.7775C67.5522 10.9494 67.6858 11.0831 67.8577 11.0831L75.1911 11.0831C75.3438 11.0831 75.4966 10.9494 75.4966 10.7775L75.4966 7.51191L72.7848 9.72719C72.04 10.3383 70.9897 10.3383 70.264 9.72719L67.5522 7.51191ZM66.6355 5.88864C66.6355 5.22024 67.1702 4.66642 67.8577 4.66642L75.1911 4.66642C75.8595 4.66642 76.4133 5.22024 76.4133 5.88864L76.4133 10.7775C76.4133 11.465 75.8595 11.9998 75.1911 11.9998L67.8577 11.9998C67.1702 11.9998 66.6355 11.465 66.6355 10.7775L66.6355 5.88864Z",
    fill: "#041E49"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_133_28948)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.14 34.4911C108.403 34.4911 108.005 34.11 108.005 33.3988L108.005 31.3132L107.748 31.3132C107.626 31.3117 107.508 31.2607 107.422 31.1722C107.337 31.0837 107.29 30.9651 107.293 30.8421C107.299 30.5945 107.501 30.3965 107.748 30.395L108.005 30.395L108.005 29.7738C108.027 29.4978 108.257 29.2832 108.535 29.2832C108.812 29.2832 109.044 29.4963 109.064 29.7738L109.064 30.395L109.477 30.395C109.595 30.3985 109.707 30.4482 109.79 30.5338C109.873 30.6193 109.92 30.7341 109.921 30.8541C109.92 30.9741 109.873 31.0889 109.79 31.1745C109.707 31.26 109.595 31.3098 109.477 31.3132L109.064 31.3132L109.064 33.1167C109.064 33.4318 109.263 33.5548 109.429 33.5548L109.52 33.5548C109.818 33.5548 109.985 33.7529 109.985 34.0109C109.985 34.269 109.827 34.4911 109.14 34.4911Z",
    fill: "#FF4C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.451 34.491C111.135 34.491 110.34 33.5308 110.34 32.389C110.34 31.2562 111.137 30.2959 112.451 30.2959C113.776 30.2959 114.571 31.2562 114.571 32.389C114.58 32.6721 114.531 32.954 114.427 33.2167C114.323 33.4794 114.166 33.7172 113.966 33.9149C113.767 34.1126 113.529 34.266 113.268 34.3652C113.008 34.4643 112.729 34.5072 112.451 34.491ZM112.451 31.2307C111.796 31.2307 111.433 31.7678 111.433 32.389C111.433 33.0101 111.798 33.5578 112.451 33.5578C113.105 33.5578 113.478 33.0207 113.478 32.389C113.478 31.7678 113.105 31.2307 112.451 31.2307ZM118.287 34.4415L118.205 34.4415C118.122 34.4415 117.749 34.3755 117.749 33.9779C117.476 34.3005 117.005 34.491 116.483 34.491C115.846 34.491 115.092 34.0604 115.092 33.1662C115.092 32.2314 115.846 31.8759 116.483 31.8759C117.014 31.8759 117.485 32.0499 117.749 32.3635L117.749 31.8248C117.749 31.4197 117.401 31.1542 116.871 31.1542C116.555 31.1475 116.243 31.2368 115.977 31.4107C115.919 31.4463 115.854 31.4664 115.787 31.4692C115.565 31.4662 115.388 31.2847 115.388 31.0641C115.39 30.9912 115.409 30.9199 115.446 30.8571C115.694 30.4595 116.588 30.2944 117.051 30.2944C117.961 30.2944 118.798 30.659 118.798 31.8083L118.798 33.9194C118.799 34.2045 118.57 34.4385 118.284 34.44L118.287 34.4415ZM117.749 32.9351C117.575 32.7041 117.244 32.587 116.905 32.587C116.49 32.587 116.151 32.8001 116.151 33.1917C116.151 33.5638 116.49 33.7799 116.905 33.7799C117.244 33.7799 117.575 33.6643 117.749 33.4318L117.749 32.9351Z",
    fill: "#FF4C00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.285 34.4911C120.764 34.4911 119.928 34.317 119.68 33.9599C119.631 33.8954 119.605 33.8174 119.606 33.7364C119.609 33.6199 119.657 33.5091 119.738 33.4274C119.82 33.3457 119.93 33.2994 120.044 33.2983C120.121 33.2983 120.195 33.3193 120.26 33.3598C120.574 33.5413 120.989 33.6824 121.335 33.6824C121.791 33.6824 122.006 33.5008 122.006 33.2517C122.006 32.5901 119.63 33.1272 119.63 31.5548C119.63 30.8841 120.218 30.2975 121.269 30.2975C121.79 30.2975 122.502 30.464 122.726 30.7851C122.769 30.8442 122.792 30.9157 122.793 30.9892C122.785 31.2112 122.602 31.3883 122.38 31.3868C122.31 31.3869 122.242 31.3699 122.18 31.3372C121.904 31.1802 121.593 31.0976 121.276 31.0972C120.896 31.0972 120.648 31.2712 120.648 31.4948C120.648 32.0904 123.015 31.5938 123.015 33.2067C123.015 33.9359 122.394 34.4911 121.285 34.4911ZM125.134 34.4911C124.398 34.4911 123.999 34.11 123.999 33.3988L123.999 31.3132L123.743 31.3132C123.62 31.3117 123.502 31.2607 123.417 31.1722C123.331 31.0837 123.284 30.9651 123.287 30.8421C123.293 30.5945 123.495 30.3965 123.743 30.395L123.999 30.395L123.999 29.7738C124.011 29.6396 124.073 29.5148 124.171 29.424C124.269 29.3332 124.396 29.283 124.529 29.2832C124.806 29.2832 125.038 29.4963 125.059 29.7738L125.059 30.395L125.473 30.395C125.591 30.3985 125.703 30.4482 125.786 30.5338C125.869 30.6193 125.916 30.7341 125.917 30.8541C125.916 30.9741 125.869 31.0889 125.786 31.1745C125.703 31.26 125.591 31.3098 125.473 31.3132L125.059 31.3132L125.059 33.1167C125.059 33.4318 125.258 33.5548 125.423 33.5548L125.514 33.5548C125.812 33.5548 125.978 33.7529 125.978 34.0109C125.978 34.269 125.823 34.4911 125.134 34.4911Z",
    fill: "#FF4C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.618 32.8474C106.624 32.4047 106.605 31.9621 106.561 31.5225C106.528 31.2254 106.43 30.8443 106.112 30.7663C106.153 30.7769 106.196 30.7753 106.236 30.7618C106.604 30.5668 106.576 30.0851 106.446 29.737C106.275 29.2809 105.869 28.9568 105.466 28.7423C104.719 28.3635 103.891 28.1808 103.057 28.211C102.223 28.2411 101.41 28.4831 100.691 28.9148C100.327 29.1429 99.9078 29.5885 100.092 30.0851C100.142 30.2087 100.216 30.3209 100.309 30.4152L100.448 30.5623C100.26 30.8203 100.123 31.0544 100.035 31.368C99.7692 32.3132 99.8134 32.9209 99.8857 33.6801C99.9314 34.1497 100.083 34.8489 100.616 34.9269C101.05 34.9884 101.52 34.8429 101.954 34.7904C102.432 34.7334 102.914 34.6433 103.398 34.6568C104.08 34.6748 104.755 34.8384 105.438 34.8459C105.798 34.8489 106.397 34.8849 106.505 34.4018C106.607 33.9426 106.611 33.4655 106.611 32.9974C106.617 32.9479 106.617 32.8969 106.617 32.8489L106.618 32.8474ZM105.84 33.6411C105.67 34.0297 105.19 33.9862 104.856 33.9577L103.358 33.7761C102.913 33.7626 102.472 33.8481 102.038 33.9456C101.713 34.0177 101.261 34.2082 100.967 33.9547C100.641 33.6741 100.583 33.1955 100.579 32.7918C100.585 32.4274 100.621 32.0641 100.685 31.7056C100.725 31.4835 100.79 31.2674 100.876 31.0604C100.992 30.7603 101.165 30.5788 101.174 30.5878C101.086 30.4962 100.982 30.4467 100.923 30.3222C100.7 29.8496 101.256 29.449 101.56 29.3124C102.624 28.8293 104.111 28.8773 105.115 29.497C105.428 29.6905 106.036 30.3552 105.468 30.6868C105.817 30.8548 105.907 31.362 105.946 31.7221C106.007 32.3004 105.989 32.8847 105.893 33.458C105.882 33.5212 105.865 33.5827 105.84 33.6411Z",
    fill: "#FF4C00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_133_28948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.5385,
    height: 7.14497,
    fill: "white",
    transform: "translate(99.6353 28)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastCheckEmail);
export default __webpack_public_path__ + "static/media/toast-check-email.8562d41169c6b39764a3721aa029d2f1.svg";
export { ForwardRef as ReactComponent };